import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreIputWithValidationComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-input-with-validation/mapfre-input-with-validation.component';
import { ProfileConfirmModalComponent } from '../../../dashboard/loggedin-content/profile/profile-confirm-modal/profile-confirm-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { UpdatePasswordService } from './../../../../_services/signup-process-service/update-password.service';
import { ProfileSettingsRoutingService } from '../../../../_services/profile-settings/profile-settings-routing.service';
import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Params, Router, RouterModule } from '@angular/router';
import {
  AcmicService,
  AlertService,
  FormBase,
  FormBaseControlService,
  GTagService,
} from '@mapfre-design-library/src/public_api';

// --- Components | Services | Models --- //
import { AuthenticationService } from '../../../../_services/_iam/authentication-service.service';
import { UserService } from '../../../../_services/user.service';
import { ProfileConfirmModalService } from '../../../../_services/profile-settings/profile-confirm-modal.service';
import { StorageServiceObservablesService } from '../../../../_services/storage-service-observables/storage-service-observables.service';
import { ErrorRedirectionService } from '../../../../_services/error-service/error-redirection.service';
import { CookieService } from 'ngx-cookie-service';
import { ChangeEmailService } from '../../../../_services/profile-settings/change-email.service';
import { TranslateService } from '@ngx-translate/core';
import { ParamHandlingService } from '@services/misc-services/param-handling.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, ProfileConfirmModalComponent, MapfreIputWithValidationComponent, MapfreButtonComponent],
  selector: 'app-create-password-form',
  templateUrl: './create-password-form.component.html',
  providers: [FormBaseControlService],
})
export class CreatePasswordFormComponent implements OnInit {
  @Input() inputs: FormBase<any>[] = [];
  @Input() userData: any;
  createPasswordForm: FormGroup;
  isAcmic: boolean;
  email: string;
  token: string;
  user: any = {};
  whereInTheProcess: string;
  confirmModal: boolean;
  createUserInfo: any;
  @Output() confirmationOfPasswordCreation: EventEmitter<boolean> =
    new EventEmitter();
  enableBtn = false;
  loader = false;
  utmQueryParams: { [key: string]: string; };
  errorMessage: string;
  constructor(
    private activeRoute: ActivatedRoute,
    private alertService: AlertService,
    private authenticationService: AuthenticationService,
    private ipt: FormBaseControlService,
    public router: Router,
    private userService: UserService,
    private profileSettingsRoutingService: ProfileSettingsRoutingService,
    private profileConfirmModalService: ProfileConfirmModalService,
    private storageService: StorageServiceObservablesService,
    private updatePasswordService: UpdatePasswordService,
    private errorRedirectionService: ErrorRedirectionService,
    private cookieService: CookieService,
    private changeEmailService: ChangeEmailService,
    private gTagService: GTagService,
    private translate: TranslateService,
    private paramHandlingService: ParamHandlingService,
    private acmicService: AcmicService
  ) { }

  createNewPassword(): void {
    if (this.whereInTheProcess == 'createpassword') {
      this.createPassword(this.userData);
    } else if (this.whereInTheProcess == 'createnewpassword') {
      this.createNewAccount(this.userData);
    } else {
      this.updatePassword();
    }
  }

  createPassword(userObject): void {
    this.loader = true;
    userObject.password = this.createPasswordForm.value.createPassword;
    this.userService.updateUser(userObject);
    this.authenticationService
      .confirmPolicyAndAccount(this.userService)
      .subscribe(
        () => {
          this.triggerValidationEmail();
        },
        (error) => {
          this.loader = false;
          this.gTagService.triggerFormLink(
            'createPasswordForm',
            'false',
            this.translate.instant('CREATE_PASSWORD_ERROR')
          );
          this.errorRedirectionService.errorRedirectHandler(error);
        }
      );
  }

  createNewAccount(userObject): void {
    if (this.token) {
      this.createNewAccForNonCommPolicy();
    } else {
      this.createNewAccForCommercialPolicy(userObject);
    }
  }
  createNewAccForNonCommPolicy() {
    this.loader = true;
    this.email = this.email
      ? this.email.toLowerCase()
      : this.storageService.getUserFromStorage().toLowerCase();
    const user = {
      password: this.createPasswordForm.value.createPassword,
      email: this.email,
      token: this.token,
    };

    this.authenticationService.activateAccount(user).subscribe(
      () => {
        this.gTagService.triggerFormLink('createPasswordForm', 'true', '');
        this.loader = false;
        this.alertService.success('PASSWORD_CREATED_PLEASE_LOGIN', true);
        this.cookieService.deleteAll();
        if (this.acmicService.isACMIC() && Object.keys(this.utmQueryParams).length) {
          this.router.navigate(['login'], { queryParams: this.utmQueryParams, queryParamsHandling: 'merge' });
        } else {
          this.router.navigate(['login']);
        }
      },
      (errors) => this.commonErrorHadler(errors)
    );
  }
  createNewAccForCommercialPolicy(userObject) {
    this.loader = true;
    userObject.password = this.createPasswordForm.value.createPassword;
    this.userService.updateUser(userObject);
    this.authenticationService.createPassword(this.userService).subscribe(
      () => {
        this.triggerValidationEmail();
      },
      (errors) => this.commonErrorHadler(errors)
    );
  }
  triggerValidationEmail() {
    this.gTagService.triggerFormLink('createPasswordForm', 'true', '');
    this.loader = false;
    this.router.navigate(['signup', 'validate-email-ca']);
  }
  commonErrorHadler(error) {
    this.loader = false;
    this.gTagService.triggerFormLink(
      'createPasswordForm',
      'false',
      this.translate.instant('CREATE_PASSWORD_ERROR')
    );
    this.errorRedirectionService.errorRedirectHandler(error);
  }
  updateAccountEmail() {
    const requestBody = {
      email: this.email,
      password: '',
    };
    this.changeEmailService
      .updateAccountEmail(this.userData.email, this.token, requestBody)
      .subscribe(
        () => {
          //do ntohing
        },
        (error) => {
          if (error.status) {
            this.errorRedirectionService.redirect(error.status);
          }
        }
      );
  }

  updatePassword(): void {
    this.loader = true;
    this.email = this.email
      ? this.email.toLowerCase()
      : this.storageService.getUserFromStorage().toLowerCase();
    const oldPass = this.profileSettingsRoutingService.getOldPassword();
    this.errorMessage = '';
    const user = {
      password: this.createPasswordForm.value.createPassword,
      email: this.email,
      token: this.token,
      oldPass,
    };

    if (this.whereInTheProcess === 'edit-password') {
      this.authenticationService.updatePassword(user).subscribe(
        () => {
          this.gTagService.triggerFormLink('createPasswordForm', 'true', '');
          this.loader = false;
          this.profileSettingsRoutingService.setChangePasswordAlert(true);
          this.profileSettingsRoutingService.clearPasswordProcess();
          this.profileSettingsRoutingService.clearOldPassword();
          this.alertService.success('SUCCESS_FORGOT_PASSWORD', true);
          this.router.navigate(['/profile']);
        },
        (error) => {
          this.gTagService.triggerFormLink(
            'createPasswordForm',
            'false',
            this.translate.instant('UPDATE_PASSWORD_ERROR')
          );
          this.loader = false;
          this.errorMessage = error?.error?.Message;
          // this.errorRedirectionService.errorRedirectHandler(error);
        }
      );
    } else {
      this.authenticationService.updatePassword(user).subscribe(
        () => {
          this.gTagService.triggerFormLink('createPasswordForm', 'true', '');
          this.loader = false;
          this.authenticationService.login(user.email, user.password).subscribe(
            (accessToken) => {
              accessToken.subscribe((tokenFromRes) => {
                this.alertService.success('FORGOT_PASSWORD_SUCCESSFULLY', true);
                localStorage.removeItem('createuserinfo');
                this.updatePasswordService.createLocalStorageUser(
                  tokenFromRes,
                  user.email,
                  user.password
                );
              });
            },
            (error) => {
              this.loader = false;
              if (
                error.status === 400 ||
                error.status === 401 ||
                error.status === 403 ||
                error.status === 404 ||
                error.status === 408
              ) {
                this.confirmationOfPasswordCreation.emit(false);
                this.alertService.error(error.message);
              } else {
                this.errorRedirectionService.errorRedirectHandler(error);
              }
            }
          );
        },
        (error) => {
          this.gTagService.triggerFormLink(
            'createPasswordForm',
            'false',
            this.translate.instant('UPDATE_PASSWORD_ERROR')
          );
          this.errorRedirectionService.errorRedirectHandler(error);
        }
      );
    }
  }

  onCheckDirty() {
    this.profileConfirmModalService.onCheckDirty(this.createPasswordForm);
    this.profileConfirmModalService.$checkDirty.subscribe((value) => {
      this.confirmModal = value;
    });

    if (this.confirmModal === false) {
      this.router.navigate(['/profile']);
    }
  }

  isPasswordValid(isValid) {
    this.enableBtn = isValid;
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.utmQueryParams = this.paramHandlingService.getUtmQueryParams();
    this.createPasswordForm = this.ipt.toFormGroup(this.inputs);
    // url paramaters for example ?token=token
    this.activeRoute.queryParams.subscribe((params: Params) => {
      this.email = params.email;
      this.token = params.token;
    });

    this.whereInTheProcess = this.activeRoute.snapshot.routeConfig.path;
    this.userService.$user.subscribe((userData) => {
      this.userData = userData;
    });

    this.createUserInfo = JSON.parse(localStorage.getItem('createuserinfo'));
  }
}
